import { createRequiredContext } from '@ha/utilities/React/RequiredContext';

import { Listing, MapMarker } from '@kamernet/core/ApiClient/Kamernet';

import {
  ListingsSearchAllFilters,
  ListingsSearchBarFilters,
  ListingsSearchSideFilters,
} from '@kamernet/modules/Search/types';

export interface IListingsSearch {
  allFilters: ListingsSearchAllFilters;
  sideFilters: ListingsSearchSideFilters;
  barFilters: ListingsSearchBarFilters;
  listings: Array<Listing>;
  totalListingsCount: number;
  topListings: Array<Listing>;
  nearbyListings: Array<Listing>;
  sideFiltersCount: number;
  applyNewAllFilters: (
    newAllFilters: Partial<ListingsSearchAllFilters>,
  ) => void;
  reload: () => void;
  resetSideFilters: () => void;

  isSideFiltersFormOpen: boolean;

  toggleSideFiltersForm: () => void;

  applyNewSideFilters: (newSideFilters: ListingsSearchSideFilters) => void;
  applyNewBarFilters: (newBarFilters: ListingsSearchBarFilters) => void;

  pinListings: MapMarker[];
  activeTenantsCount: number;
}

export const ListingsSearchContext = createRequiredContext<IListingsSearch>(
  'ListingsSearchContext',
);
